<template>
  <v-container>
    <v-breadcrumbs :items="breadcrumbs" class="pl-0 py-1">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-row>
      <v-col cols>
        <div class="v-toolbar__title">
          <b>ブロック一覧</b>
          <span>（{{ totalBlocks }} 件）</span>
        </div>
      </v-col>
      <v-col cols="auto">
        <v-dialog
          v-model="createBlockDialog"
          @input="(v) => v || closeCreateBlockDialog()"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              <v-icon left>mdi-earth-box-plus</v-icon>ブロック追加
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">ブロック追加</span>
            </v-card-title>

            <v-card-text class="pb-0">
              <v-container class="pb-0">
                <p>* は必須項目です。</p>
                <v-form
                  ref="createBlockForm"
                  v-model="createBlockFormValid"
                  lazy-validation
                >
                  <v-text-field
                    v-model="inputCreateBlock.name"
                    label="ブロック名 *"
                    required
                    :rules="[nameRules.required, commonRules.duplicate]"
                    outlined
                    clearable
                    dense
                    @click="resetFormValidation"
                  ></v-text-field>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions class="pt-0">
              <v-spacer></v-spacer>
              <v-btn depressed @click="closeCreateBlockDialog"
                >キャンセル</v-btn
              >
              <v-btn depressed color="primary" @click="createBlock">追加</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="4" md="3" v-for="item in blocks" :key="item.id">
        <v-card class="mx-auto" max-width="350">
          <v-img
            lazy-src="../assets/images/no-image.png"
            :src="item.thumbnail_color_path ? item.thumbnail_color_path : item.thumbnail_thermal_path"
            :aspect-ratio="4 / 3"
            @click="viewMap(item)"
          ></v-img>
          <v-card-title>
            {{item.name}}
            <v-spacer></v-spacer>
            <v-menu left offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab depressed small v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="showDataUploadDialog(item)">
                  <v-list-item-title>
                    <v-icon left>mdi-cloud-upload</v-icon>
                    <span>データアップロード</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="viewFolderList(item)">
                  <v-list-item-title>
                    <v-icon left>mdi-folder-cog</v-icon>
                    <span>データ管理</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="openEditBlockDialog(item)">
                  <v-list-item-title>
                    <v-icon left>mdi-pencil</v-icon>
                    <span>情報編集</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="
                    sharedState.role === 'admin' ||
                    sharedState.email === item.created_user
                  "
                  @click="confirmDeleteBlock(item)"
                >
                  <v-list-item-title>
                    <v-icon left>mdi-delete</v-icon>
                    <span>削除</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="editBlockDialog"
      @input="(v) => v || closeEditBlockDialog()"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">ブロック情報編集</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container class="pb-0">
            <p>* は必須項目です。</p>
            <v-form
              ref="editBlockForm"
              v-model="editBlockFormValid"
              lazy-validation
            >
              <v-text-field
                v-model="inputEditBlock.name"
                label="ブロック名 *"
                required
                :rules="[nameRules.required, commonRules.duplicate]"
                outlined
                clearable
                dense
                @click="resetFormValidation"
              ></v-text-field>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn depressed @click="closeEditBlockDialog">キャンセル</v-btn>
          <v-btn depressed color="primary" @click="editBlock">編集</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <data-upload-dialog
      v-model="uploadDataDialog"
      :blockId="selectedBlockId"
    ></data-upload-dialog>
  </v-container>
</template>

<script>
import { store } from "../store";
// import * as commonUtil from "../utils/common";
import DataUploadDialog from "./dialog/DataUploadDialog";

export default {
  name: "Block",

  components: {
    "data-upload-dialog": DataUploadDialog,
  },

  data() {
    return {
      sharedState: store.state,
      breadcrumbs: [
        {
          text: "発電所一覧",
          disabled: false,
          exact: true,
          to: "/plant",
        },
        {
          text: "",
        },
      ],
      // 表示用
      useTypeItems: [
        { text: "全て", value: "all" },
        { text: "工事", value: "1construction" },
        { text: "査定", value: "2assessment" },
        { text: "メンテ", value: "3maintenance" },
        { text: "ドローン", value: "4drone" },
      ],
      // ブロック追加・編集用
      useTypes: [
        { text: "工事", value: "1construction" },
        { text: "査定", value: "2assessment" },
        { text: "メンテ", value: "3maintenance" },
        { text: "ドローン", value: "4drone" },
      ],
      filter: {
        plant_id: this.$route.params.plantId,
      },
      createBlockDialog: false,
      editBlockDialog: false,
      uploadDataDialog: false,
      createBlockFormValid: true,
      editBlockFormValid: true,
      inputCreateBlock: {
        plant_id: this.$route.params.plantId,
        name: null,
      },
      inputEditBlock: {},
      commonRules: {
        duplicate: true,
      },
      nameRules: {
        required: (v) => (!!v && !!v.trim()) || "ブロック名を入力してください。",
      },
      useTypeRules: {
        required: (v) => !!v || "利用区分を選択してください。",
      },
      loading: true,
      tableHeaders: [
        {
          text: "ブロック名",
          sortable: true,
          value: "name",
        },
        {
          text: "作成者",
          sortable: true,
          value: "created_user",
        },
        {
          text: "撮影日",
          sortable: true,
          value: "property.shooting_date",
        },
        {
          text: "撮影機体",
          sortable: true,
          value: "property.drone_type",
        },
        {
          text: "高度(M)",
          sortable: true,
          value: "property.shooting_height",
        },
        {
          text: "ジンバル角度",
          sortable: true,
          value: "property.gimbal_angle",
        },
        {
          text: "GCP",
          sortable: true,
          value: "property.gcp",
        },
        {
          text: "アクション",
          sortable: false,
          value: "actions",
          align: "center",
        },
      ],
      plant: {},
      totalBlocks: 0,
      blocks: [],
      selectedBlockId: null,
    };
  },

  methods: {
    resetData() {
      this.loading = true;
      this.totalBlocks = 0;
      this.blocks = [];
    },
    getBlocks() {
      this.resetData();
      this.axios.post("/api/blocks", this.filter).then((response) => {
        this.loading = false;
        this.blocks = response.data;
        this.totalBlocks = this.blocks.length;
      });
    },
    getPlant() {
      this.axios
        .get("/api/main-plant/" + this.$route.params.plantId)
        .then((response) => {
          this.plant = response.data;
          this.breadcrumbs[1].text = this.plant.plant_name;
        });
    },
    createBlock() {
      if (this.$refs.createBlockForm.validate()) {
        this.axios
          .post("/api/block", this.inputCreateBlock)
          .then((response) => {
            if (response.data == "exist") {
              this.commonRules.duplicate =
                "入力されたブロック名と利用区分は既に登録されています。再度入力してください。";
            } else {
              this.closeCreateBlockDialog();
              this.getBlocks();
              store.showSuccessDialog(
                `${response.data.name} ブロック作成が完了しました。`
              );
            }
          });
      }
    },
    closeCreateBlockDialog() {
      this.createBlockDialog = false;
      this.resetFormValidation();
      this.$refs.createBlockForm.reset();
    },
    editBlock() {
      if (this.$refs.editBlockForm.validate()) {
        this.axios
          .put("/api/block/" + this.inputEditBlock.id, this.inputEditBlock)
          .then((response) => {
            if (response.data == "exist") {
              this.commonRules.duplicate =
                "入力されたブロック名と利用区分は既に登録されています。再度入力してください。";
            } else {
              this.closeEditBlockDialog();
              this.getBlocks();
              store.showSuccessDialog("ブロック情報編集が完了しました。");
            }
          })
          .catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
          });
      }
    },
    openEditBlockDialog(block) {
      this.inputEditBlock = JSON.parse(JSON.stringify(block));
      this.editBlockDialog = true;
    },
    closeEditBlockDialog() {
      this.editBlockDialog = false;
      this.resetFormValidation();
      this.$refs.editBlockForm.reset();
    },
    viewMap(block) {
      this.axios.get(`/api/block/${block.id}/newest-folder`).then((response) => {
        this.$router.push("/map/" + response.data.id);
      }).catch(() => {
        store.showErrorDialog("このブロックにはまだマップがありません。");
      });
    },
    viewFolderList(block) {
      this.$router.push("/block/" + block.id + "/folder");
    },
    confirmDeleteBlock(block) {
      const confirmDialog = {
        title: "削除確認",
        content: `${block.name} ブロックを削除します。よろしいですか。`,
        onAgree: () => this.deleteBlock(block),
        onDisagree: null,
      };
      store.showConfirmDialog(confirmDialog);
    },
    deleteBlock(block) {
      this.axios
        .delete("/api/block/" + block.id)
        .then((response) => {
          if (response.status === 204) {
            store.showSuccessDialog(
              `${block.name} ブロック削除が完了しました。`
            );
            this.getBlocks();
          }
        })
        .catch(() => {
          store.showErrorDialog("エラーが発生しました。再度試してください。");
        });
    },
    // getBlockTitle(block) {
    //   return commonUtil.getBlockTitle(block);
    // },
    resetFormValidation() {
      this.commonRules.duplicate = true;
    },
    showDataUploadDialog(block) {
      this.selectedBlockId = block.id;
      this.uploadDataDialog = true;
    },
  },

  created() {
    this.getPlant();
    this.getBlocks();
  },
};
</script>

<style lang="scss">
.v-card > .v-image:hover {
  opacity: 0.5;
  transition: 0.3s;
  cursor: pointer;
}
</style>
